import script from "./LumpSumsHL.vue?vue&type=script&setup=true&lang=ts"
export * from "./LumpSumsHL.vue?vue&type=script&setup=true&lang=ts"

import "./LumpSumsHL.vue?vue&type=style&index=0&id=10bfb05f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10bfb05f"]])

export default __exports__